import { useState} from 'react';
import useReplaceUrl from '../hooks/useReplaceUrl';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Comments from './Comments';

export default function Capitulo6() {
    const section = 'camazotz';
    const title = 'Camazotz';
    const description = 'Unas horas antes de la Noche de Muertos, llegué a casa de mi familia en Tzintzuntzan.';
    const text = '<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda porro modi numquam tempore iste quis provident dolorem maiores consectetur id? Quaerat sapiente nemo laborum doloremque repellat nulla explicabo praesentium odio.</p><p>Lorem ipsum dolor sit amet consectetur</p>';
    const image = 'https://www.diadelavida.com/images/chapters/deco_capitulo1.png';
    const image_size = 'contain';
    const image_position = 'center';
    const image_height = 400;
    const comments_prompt = 'Oh no...';

    const images = [
        {
            id: 1,
            src: `https://www.diadelavida.com/images/chapters/capitulo6_main.jpg?${Date.now()}`,
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 5',
            description: 'Camazotz...'
        },
        {
            id: 2,
            src: `https://www.diadelavida.com/images/chapters/capitulo6_secondary.jpg?${Date.now()}`,
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 5',
            description: '...se ha liberado'
        },
    ];

    const [selectedImage, setSelectedImage] = useState(null);

    useReplaceUrl(section);

    return (
        <div>
            <div className="chapter_image camazotz">
                <div className="container mainMargin">
                    <div className="row">
                    <div className="col-xl-1 mb-3">
                        <Link to="/capitulos">
                        <img 
                            src={`https://www.diadelavida.com/images/layout/chapters_back.png?${Date.now()}`} 
                        />
                        </Link>
                    </div>
                    <div
                        className={`${images.length < 3 ? 'col-xl-9 col-md-10' : 'col-xl-8 col-md-9'} mb-3`}
                    >
                        <div className="page shadow">
                        <h2 style={{backgroundImage:  `url(https://www.diadelavida.com/images/numbers/6.png`, display: 'none'}}>Camazotz</h2>
                        <div className='main_text'>"Huele a sangre..."</div>
                        <div 
                            className="image-decoration"
                            style={{ minHeight: '100px' }}
                            ></div>
                        </div>
                    </div>
                    <div
                        className={`${images.length < 3 ? 'col-md-2' : 'col-md-3'} mb-5 page shadow`}
                    >
                        <div className="row">
                        {images.map((image) => (
                            <div
                            className={`col-6 ${images.length < 3 ? 'col-md-12' : ''}`}
                            key={image.id}>
                            <div
                                className="image"
                                onClick={() => setSelectedImage(image)}
                                role="button"
                            >
                                <img
                                src={image.src}
                                alt={image.alt}
                                className="img-fluid"
                                style={{ cursor: 'pointer' }}
                                />
                            </div>
                            </div>
                        ))}
                        </div>
                    </div>
                    </div>

                    {/* Modal */}
                    <Modal
                    show={!!selectedImage}
                    onHide={() => setSelectedImage(null)}
                    size="lg"
                    centered
                    className="tall-modal" 
                    >
                    <Modal.Header closeButton>
                        {/* <Modal.Title>Image Details</Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body>
                        {selectedImage && (
                        <>
                            <img
                            src={selectedImage.src}
                            alt={selectedImage.alt}
                            className="img-fluid mb-3"
                            />
                            <p>{selectedImage.description}</p>
                        </>
                        )}
                    </Modal.Body>
                    </Modal>
                </div>
                </div>
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}